import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PaiementService } from './Services/Paiement/paiement.service';
import { CotationService } from './Services/Cotation/cotation.service';
import { AssureurService } from './Services/Assureur/assureur.service';
import { HistoriqueService } from './Services/historique/historique.service';
import { HistoriqueDetailService } from './Services/historique/historiquedetail.service';
import { authGuardService } from './Services/guards/authGuard.service';

const routes: Routes = [

  {
    canActivate: [authGuardService],
    path: 'menu',

    loadChildren: () => import('./Pages/menu/menu.module')
        .then(m => m.MenuPageModule),

},

// {
//     path: '',
//     loadChildren: () => import('./index/index.module').then(m => m.IndexPageModule)
// },

{
  path:'signup',
  loadChildren:() => import('./Pages/signup/signup.module')
  .then(m => m.SignupPageModule)
},
{
    canActivate: [authGuardService],
    path: 'menu-principal',

    loadChildren: () => import('./Pages/menu-principal/menu_prince.module')
        .then(m => m.MenuPrincipalPageModule),

},

{
    canActivate: [authGuardService],
    path: 'prime',
    resolve: {
        itemsList: PaiementService
    },
   
    loadChildren: () => import('./Pages/prime/prime.module')
        .then(m => m.PrimePageModule),
},
{
    canActivate: [authGuardService],
    path: 'cotationhistorique/:Q/:P/:I/:T',

    resolve: {
        cotationList: CotationService
    },
    loadChildren: () => import('./Pages/cotationhistorique/cotationhistorique.module')
        .then(m => m.CotationhistoriquePageModule),
},
{
    canActivate: [authGuardService],
    path: 'cotationhistorique',
    resolve: {
        cotationList: CotationService
    },
    loadChildren: () => import('./Pages/cotationhistorique/cotationhistorique.module')
        .then(m => m.CotationhistoriquePageModule),
},
{
    canActivate: [authGuardService],
        path: 'cotation',
        loadChildren: () => import('./Pages/cotation/cotation.module')
            .then(m => m.CotationPageModule),
       
},
{
    canActivate: [authGuardService],
    path: 'cotation/assureur-choix/:id',
    loadChildren: () => import('./Pages/cotation/assureur-choix/assureur-choix.module').then( m => m.AssureurChoixPageModule)

},
{
    canActivate: [authGuardService],
    path: 'pub',
    // resolve: {
    //     itemsList: PaiementService
    // },
    loadChildren: () => import('./Pages/publicite/pub.module')
        .then(m => m.PubpageModule),
},
{
    canActivate: [authGuardService],
    path: 'formulaireauto',
    // resolve: {
    //     itemsList: PaiementService
    // },
    loadChildren: () => import('./Pages/formulaireAuto/formulaireauto.module')
        .then(m => m.FormulaireAutoPageModule),
},




{canActivate: [authGuardService],
  path: 'sous-auto-step0',
  loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step0/souscriptionauto-step0.module').then( m => m.SousAutoStep0PageModule)
},
{canActivate: [authGuardService],
  path: 'sous-auto-step1',
  loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step1/souscriptionauto-step1.module').then( m => m.SousAutoStep1PageModule)
},
{canActivate: [authGuardService],
  path: 'sous-auto-step2',
  loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step2/souscriptionauto-step2.module').then( m => m.SousAutoStep2PageModule)
},
{canActivate: [authGuardService],
  path: 'sous-auto-step3',
  loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step3/souscriptionauto-step3.module').then( m => m.SousAutoStep3PageModule)
},
{canActivate: [authGuardService],
  path: 'sous-auto-step4',
  loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step4/souscriptionauto-step4.module').then( m => m.SousAutoStep4PageModule)
},
{canActivate: [authGuardService],
  path: 'sous-auto-step_4',
  loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step_4/souscriptionauto-step_4.module').then( m => m.SousAutoStep_4PageModule)
},
{canActivate: [authGuardService],
  path: 'sous-auto-step5',
  loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step5/souscriptionauto-step5.module').then( m => m.SousAutoStep5PageModule)
},



/*--------------------------------------
2022-02-25T 13:21:53.000-05:00
-----------------------------------------*/

{canActivate: [authGuardService],
  path: 'sous-mrh-step1',
  loadChildren: () => import('./Components/Composant_Simulateur/mrh/souscription-mrh/souscriptionmrh-step1/souscriptionmrh-step1.module').then( m => m.SousMrhStep1PageModule)
},
// {canActivate: [authGuardService],
//   path: 'sous-auto-step1',
//   loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step1/souscriptionauto-step1.module').then( m => m.SousAutoStep1PageModule)
// },
// {canActivate: [authGuardService],
//   path: 'sous-auto-step2',
//   loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step2/souscriptionauto-step2.module').then( m => m.SousAutoStep2PageModule)
// },
// {canActivate: [authGuardService],
//   path: 'sous-auto-step3',
//   loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step3/souscriptionauto-step3.module').then( m => m.SousAutoStep3PageModule)
// },
// {canActivate: [authGuardService],
//   path: 'sous-auto-step4',
//   loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step4/souscriptionauto-step4.module').then( m => m.SousAutoStep4PageModule)
// },
// {canActivate: [authGuardService],
//   path: 'sous-auto-step_4',
//   loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step_4/souscriptionauto-step_4.module').then( m => m.SousAutoStep_4PageModule)
// },
// {canActivate: [authGuardService],
//   path: 'sous-auto-step5',
//   loadChildren: () => import('./Pages/souscription-auto/souscriptionauto-step5/souscriptionauto-step5.module').then( m => m.SousAutoStep5PageModule)
// },






{
    canActivate: [authGuardService],
    path: 'prime/:id',
    resolve: {
        itemsList: PaiementService
    },
    
    loadChildren: () => import('./Pages/prime/prime.module')
        .then(m => m.PrimePageModule),
},
{
    canActivate: [authGuardService],
    path: 'alerts',
   // component:NotificationPage
    loadChildren:() => import('./Pages/notification/notification.module')
         .then(m => m.NotificationPageModule),
         //'../Pages/notification/notification.module#NotificationPageModule'
},
{
    canActivate: [authGuardService],
    path: 'assureurs',
    resolve: {
        assureursList: AssureurService
    },
    loadChildren: () => import('./Pages/assureurs/assureurs.module')
        .then(m => m.AssureursPageModule),
},
{
    canActivate: [authGuardService],
    path: 'garanties',
    loadChildren: () => import('./Pages/garantie/garantie.module')
        .then(m => m.GarantiePageModule),
},
{
    canActivate: [authGuardService],
    path: 'historique',
    resolve: {
        policeList: HistoriqueService
    },
    loadChildren: () => import('./Pages/historique/historique.module')
        .then(m => m.HistoriquePageModule),
},
{
    canActivate: [authGuardService],
    path: 'historiquedetail/:id',
    resolve: {
        policeDetail: HistoriqueDetailService
    },
    loadChildren: () => import('./Pages/historique detail/historiquedetail.module')
        .then(m => m.HistoriqueDetailModule),
},
{
    canActivate: [authGuardService],
    path: 'garanties/:id',
    loadChildren: () => import('./Pages/garantie/garantie.module')
        .then(m => m.GarantiePageModule),
},
{
    canActivate: [authGuardService],
    path: 'myaccount',
    loadChildren: () => import('./Pages/my-account/my-account.module')
        .then(m => m.MyAccountPageModule),
},
{
   // canActivate: [authGuardService],
    path: 'terms-conditions',
    loadChildren: () => import('./Pages/terms-conditions/terms-conditions.module')
        .then(m => m.TermsConditionsPageModule),
},
{canActivate: [authGuardService],
    path: 'chat/:id',
    loadChildren: () => import('./Pages/chat-customer/zone-chat/chat-customer.module').then( m => m.ChatCustomerPageModule)
  },

  {canActivate: [authGuardService],
    path: 'assureur-chat',
    loadChildren: () => import('./Pages/chat-customer/assureur-chat/assureur-chat.module').then( m => m.AssureurChatPageModule)
  },

  {canActivate: [authGuardService],
    path: 'sinistre-choix',
    loadChildren: () => import('./Pages/sinistre/choix-risque/sinistre-choix.module').then( m => m.SinistreChoixPageModule)
  },

  {canActivate: [authGuardService],
    path: 'dec-auto-step1',
    loadChildren: () => import('./Pages/sinistre/declaration/auto/auto-step1/auto-step1.module').then( m => m.AutoStep1PageModule)
  },
  {canActivate: [authGuardService],
    path: 'dec-auto-step2',
    loadChildren: () => import('./Pages/sinistre/declaration/auto/auto-step2/auto-step2.module').then( m => m.AutoStep2PageModule)
  },
  {canActivate: [authGuardService],
    path: 'dec-auto-step3',
    loadChildren: () => import('./Pages/sinistre/declaration/auto/auto-step3/auto-step3.module').then( m => m.AutoStep3PageModule)
  },
  {canActivate: [authGuardService],
    path: 'dec-auto-step4',
    loadChildren: () => import('./Pages/sinistre/declaration/auto/auto-step4/auto-step4.module').then( m => m.AutoStep4PageModule)
  },
  {canActivate: [authGuardService],
    path: 'dec-auto-step5',
    loadChildren: () => import('./Pages/sinistre/declaration/auto/auto-step5/auto-step5.module').then( m => m.AutoStep5PageModule)
  },
  {canActivate: [authGuardService],
    path: 'dec-auto-step6',
    loadChildren: () => import('./Pages/sinistre/declaration/auto/auto-step6/auto-step6.module').then( m => m.AutoStep6PageModule)
  },
  {canActivate: [authGuardService],
    path: 'dec-auto-step7',
    loadChildren: () => import('./Pages/sinistre/declaration/auto/auto-step7/auto-step7.module').then( m => m.AutoStep7PageModule)
  },
//   {canActivate: [authGuardService],
//     path: 'dec-auto-step2',
//     loadChildren: () => import('./Pages/sinistre/declaration/auto/auto-step2/auto-step2.module').then( m => m.AutoStep2PageModule)
//   },

    {
        path: 'politique-conf',
        loadChildren: () => import('./Pages/politique-confidencialité/politique-conf.module')
            .then(m => m.PolitiqueConfPageModule),
    },
    {
      path:'login',
      loadChildren:() => import('./Pages/login/login.module')
      .then(m => m.LoginPageModule)
    },
    {
      path:'verify_user',
      loadChildren:() => import('./Pages/Authentication/Verify_user/verify_user.module')
      .then(m => m.VerifUserPageModule)
    },
    {
      path:'recover_user/:id',
      loadChildren:() => import('./Pages/Authentication/Reset_passwprd/reset_pass.module')
      .then(m => m.ResetpassModule)
    },
    // {
    //   path:'login/:id',
    //   loadChildren:() => import('./Pages/login/login.module')
    //   .then(m => m.LoginPageModule)
    // },
    {
      path: '',
      redirectTo:'/login',
      pathMatch:'full'
    },
    
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}

